// extracted by mini-css-extract-plugin
export default {"schedule":"table_schedule__dLBUR"};